import React, { useEffect, useState } from 'react';
import { certificateApi } from '../../services/certificateApi';

const safeList = (value) => (Array.isArray(value) ? value : []);

export const CertificateDraftBatchList = ({
  activeBatchId,
  refreshKey = 0,
  onSelect,
  api = certificateApi,
}) => {
  const [batches, setBatches] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    setStatus('loading');

    api
      .listBatches('borrador')
      .then((result) => {
        if (!active) return;
        setBatches(safeList(result));
        setStatus('ready');
      })
      .catch(() => {
        if (!active) return;
        setBatches([]);
        setStatus('error');
      });

    return () => {
      active = false;
    };
  }, [api, refreshKey]);

  return (
    <section
      className="certificate-wizard-card certificate-draft-list"
      aria-labelledby="certificate-draft-list-title"
    >
      <div className="certificate-wizard-card-heading">
        <span aria-hidden="true">5</span>
        <div>
          <h2 id="certificate-draft-list-title">Lotes pendientes de aprobación</h2>
          <p>Retoma una generación para descargarla, publicarla o cancelarla.</p>
        </div>
      </div>

      {status === 'loading' && <p role="status">Cargando lotes pendientes...</p>}
      {status === 'error' && (
        <p className="certificate-wizard-status" role="alert">
          No fue posible cargar los lotes pendientes.
        </p>
      )}
      {status === 'ready' && batches.length === 0 && (
        <p>No hay lotes pendientes de aprobación.</p>
      )}
      {status === 'ready' && batches.length > 0 && (
        <ul className="certificate-draft-items">
          {batches.map((batch) => {
            const selected = Number(activeBatchId) === Number(batch.id_lote);
            return (
              <li key={batch.id_lote}>
                <div>
                  <strong>{batch.capacitacion}</strong>
                  <span>
                    Lote {batch.id_lote} · {batch.total} constancias ·{' '}
                    {batch.estado}
                  </span>
                </div>
                <button
                  type="button"
                  className="secondary"
                  disabled={selected}
                  onClick={() => onSelect(batch)}
                >
                  {selected ? 'Lote seleccionado' : 'Revisar lote'}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};
